<template>
  <div class="container">
    <content-template>
      <template slot="left">滙業盃專區</template>
      <template slot="right">
        <li><a href="#" class="is-check" style="color: #5571EC;">線上報名</a></li>
        <li>
          <router-link to="download">下載表格</router-link>
        </li>
        <li>
          <router-link to="huiye-rule">簡介及比賽規章</router-link>
        </li>
      </template>
      <template slot="banner">
        <img :src="otherDetail.banner" class="col-xs-12" style="padding:0px;" alt="">
      </template>
      <template slot="content">
        <div class="hy-form col-xs-12 col-sm-8 col-sm-offset-2 none-padding" v-if="!isSuccess">
          <template v-if="otherDetail.start_time < nowTime && otherDetail.end_time > nowTime">
            <!--<form id="the-form" >-->
            <!--<form id="the-form" enctype="multipart/form-data" @submit.prevent="addPost">-->
            <form id="the-form" @submit.prevent="addPost">

              <div class="hy-top">
                <div class="top-left col-md-6 ">
                  <div>
                    <div class="label-div"><span class="labels">1</span><br>
                      <div>&nbsp;</div>
                    </div>
                    <div class="label1"><span class="title">填寫報名表格資料 /</span><br>
                      <span class="desc">請填寫以下學校資料及組員資料</span></div>
                  </div>

                </div>
                <div class="top-right col-md-6">
                  <div>
                    <div class="label-div"><span class="labels">2</span><br>
                      <div>&nbsp;</div>
                    </div>
                    <div class="label1"><span class="title">電郵通知 /</span><br>
                      <span class="desc">提交資料成功後系統將有電郵通知</span></div>
                  </div>
                </div>
              </div>  <!-- 頂部提示結束 -->

              <div class="team clearfix">
                <h4>參賽隊伍資料 /</h4>
                <div class="col-xs-12 col-md-6 one-frame">
                  <span class="col-xs-4 col-md-4">參賽組別：</span>
                  <select class="col-xs-8 col-md-8" v-model="team.group" name="group" id="group" >
                    <option value="1">初中組</option>
                    <option value="2">高中組</option>
                  </select>

                </div>
                <div class="col-sm-12 col-md-6 one-frame">
                  <span class="col-xs-5 col-md-4">隊伍組合形式：</span>
                  <div class="col-xs-7 col-md-8" style="display:inline-block; padding:0px;">
                    <div class=" col-md-6" style="display:inline-block; padding:0px;">
                      <input type="radio" name="team-type" value="1" v-model="team.team_cate">自由組隊
                    </div>
                    <input type="radio" name="team-type" value="2" v-model="team.team_cate">學校選派隊伍
                  </div>
                </div>
                <div class="col-xs-12 col-md-12 one-frame">
                  <span class="col-xs-4 col-md-2">參賽隊名<label style="color: red">*</label>：</span>
                  <div class="col-xs-8 col-md-10 " style="padding:0px;">
                    <input class="input-width" required="required" type="text" name="team_name" placeholder="*(注意：隊名不可有不雅字眼)" v-model="team.team_name">
                    <div class="tips ">中文隊名不得超過五個中文字,英文隊名全名不得超過十五個英文字母</div>
                  </div>
                </div>
                <div class="clearfix">
                  <div class="col-xs-12 col-md-6 one-frame">

                    <span class="col-xs-4 col-md-4 none-padding-right">參賽學校<label style="color: red">*</label>：</span>
                    <input class="col-xs-8 col-md-8" v-model="team.school" required="required" type="text">
                  </div>
                  <div class="col-sm-12 col-md-6 one-frame">

                    <span class="col-xs-4 col-md-4">帶隊老師：</span>
                    <div class="col-xs-8 col-md-8" style="display:inline-block">
                      <div class="col-xs-6 col-md-6">
                        <input type="radio" name="radio" value="1">有
                      </div>
                      <input type="radio" name="radio" value="2">沒有
                    </div>
                  </div>
                </div>

                <div class="col-xs-12 col-md-6 one-frame">

                  <span class="col-xs-4 col-md-4 none-padding-right">指導老師<label style="color: red">*</label>：</span>
                  <input class="col-xs-8 col-md-8" v-model="team.teacher_name" required="required" type="text">
                </div>
                <div class="col-xs-12 col-md-6 one-frame">

                  <span class="col-xs-4 col-md-4">帶隊老師所屬學校：</span>
                  <input class="col-xs-8 col-md-8" v-model="team.teacher_school" type="text">
                </div>
                <div class="col-xs-12 col-md-6 one-frame">
                  <span class="col-xs-4 col-md-4 none-padding-right">電郵地址<label style="color: red">*</label>：</span>
                  <div class="col-xs-8 col-md-8" style="padding:0px;">
                    <input class="input-width" required="required" v-model="team.email" style="" type="text">
                    <div class="tips ">報名完成後，此電郵將收到參考編號表示報名成功。</div>
                  </div>
                </div>
                <div class="col-xs-12 col-md-6 one-frame">
                  <span class="col-xs-4 col-md-4 none-padding-right">聯絡電話<label style="color: red">*</label>：</span>
                  <input class="col-xs-8 col-md-8" required="required" v-model="team.mobile" type="text">
                </div>
              </div>

              <div class="team-member ">
                <h4>參賽隊伍详细資料 /</h4>

                <div class="one-member clearfix">
                  <h4>隊長</h4>
                  <div class="col-xs-12 col-md-6 one-frame">

                    <span class="col-xs-4 col-md-4 none-padding-right">學生姓名<label style="color: red">*</label>：</span>
                    <input class="col-xs-8 col-md-8" required="required" v-model="teamMember1.student_name" type="text">
                  </div>
                  <div class="col-xs-12 col-md-6 one-frame">

                    <span class="col-xs-4 col-md-4 none-padding">學生證號碼<label style="color: red">*</label>：</span>
                    <input class="col-xs-8 col-md-8" required="required" v-model="teamMember1.id_card_number" type="text">
                  </div>
                  <div class="col-xs-12 col-md-6 one-frame">

                    <span class="col-xs-4 col-md-4 none-padding-right">手提電話<label style="color: red">*</label>：</span>
                    <input class="col-xs-8 col-md-8" required="required" v-model="teamMember1.mobile" type="text">
                  </div>
                  <div class="col-xs-12 col-md-6 one-frame">

                    <span class="col-xs-4 col-md-4">電郵<label style="color: red">*</label>：</span>
                    <input class="col-xs-8 col-md-8" required="required" v-model="teamMember1.email" type="text">
                  </div>
                  <div class="clearfix">
                    <div class="col-xs-12 col-md-6 one-frame">

                      <span class="col-xs-4 col-md-4">就讀中學名稱<label style="color: red">*</label>：</span>
                      <input class="col-xs-8 col-md-8" required="required" v-model="teamMember1.school" type="text">
                    </div>
                    <div class="col-xs-12 col-md-6 one-frame">

                      <span class="col-xs-4 col-md-4 none-padding-right">就讀年級<label style="color: red">*</label>：</span>
                      <select class="col-xs-8 col-md-8" v-model="teamMember1.grade" name="" id="">
                        <option value="1">初一</option>
                        <option value="2">初二</option>
                        <option value="3">初三</option>
                        <option value="4">高一</option>
                        <option value="5">高二</option>
                        <option value="6">高三</option>
                      </select>
                    </div>
                  </div>
                  <div class="clearfix">
                    <div class="col-xs-12 col-md-6 one-frame">

                      <span class="col-xs-4 col-md-4">地址<label style="color: red">*</label>：</span>
                      <input class="col-xs-8 col-md-8" required="required" v-model="teamMember1.address" type="text">
                    </div>
                  </div>

                  <div class="col-xs-12 col-md-12 one-frame">

                    <span class="col-xs-4 col-md-4">上載文件(最多1.5MB)<label style="color: red">*</label>：</span>
                    <a href="" class="file" v-if="!teamMember1.id_card_urls">
                      <input class="img-file-input" required="required" type="file" name="file" accept="image/png,image/gif,image/jpeg" @change="firstChange1">
                      <div class="file-tips">點擊上傳相片</div>
                      學生證
                    </a>
                    <template v-if="teamMember1.id_card_urls">
                      <div class="image-change">
                        <input type="text" :value="teamMember1.id_card_name" >
                        <input type="hidden" :value="teamMember1.id_card_urls">
                        <a class="file">
                          <input type="file" name="file" accept="image/png,image/gif,image/jpeg" @change="firstChange1">更换
                        </a>
                      </div>
                    </template>
                    <a href="" class="file" v-if="!teamMember1.student_picture_urls">
                      <input class="img-file-input" required="required"  type="file" @change="firstChange2">
                      <div class="file-tips">點擊上傳相片</div>
                      請上載穿校服之近照</a>
                    <template v-if="teamMember1.student_picture_urls" >
                      <div class="image-change">
                        <input type="hidden" name="" :value="teamMember1.student_picture_urls">
                        <input type="text" name="" :value="teamMember1.student_picture_name">
                        <a class="file">
                          <input type="file" name="file" accept="image/png,image/gif,image/jpeg" @change="firstChange2">更换
                        </a>
                      </div>
                    </template>
                  </div>
                </div>
              </div>

              <div class="team-member ">

                <div class="one-member clearfix">
                  <h4>隊員一</h4>
                  <div class="col-xs-12 col-md-6 one-frame">

                    <span class="col-xs-4 col-md-4 none-padding-right">學生姓名<label style="color: red">*</label>：</span>
                    <input required="required" class="col-xs-8 col-md-8" v-model="teamMember2.student_name" type="text">
                  </div>
                  <div class="col-xs-12 col-md-6 one-frame">

                    <span class="col-xs-4 col-md-4 none-padding">學生證號碼<label style="color: red">*</label>：</span>
                    <input required="required" class="col-xs-8 col-md-8" v-model="teamMember2.id_card_number" type="text">
                  </div>
                  <div class="col-xs-12 col-md-6 one-frame">

                    <span class="col-xs-4 col-md-4 none-padding-right">手提電話<label style="color: red">*</label>：</span>
                    <input required="required" class="col-xs-8 col-md-8" v-model="teamMember2.mobile" type="text">
                  </div>
                  <div class="col-xs-12 col-md-6 one-frame">

                    <span class="col-xs-4 col-md-4">電郵<label style="color: red">*</label>：</span>
                    <input required="required" class="col-xs-8 col-md-8" v-model="teamMember2.email" type="text">
                  </div>
                  <div class="clearfix">
                    <div class="col-xs-12 col-md-6 one-frame">

                      <span class="col-xs-4 col-md-4">就讀中學名稱<label style="color: red">*</label>：</span>
                      <input required="required" class="col-xs-8 col-md-8" v-model="teamMember2.school" type="text">
                    </div>
                    <div class="col-xs-12 col-md-6 one-frame">

                      <span class="col-xs-4 col-md-4 none-padding-right">就讀年級<label style="color: red">*</label>：</span>
                      <select class="col-xs-8 col-md-8" v-model="teamMember2.grade" name="" id="">
                        <option value="1">初一</option>
                        <option value="2">初二</option>
                        <option value="3">初三</option>
                        <option value="4">高一</option>
                        <option value="5">高二</option>
                        <option value="6">高三</option>
                      </select>
                    </div>
                  </div>
                  <div class="clearfix">
                    <div class="col-xs-12 col-md-6 one-frame">

                      <span class="col-xs-4 col-md-4">地址<label style="color: red">*</label>：</span>
                      <input required="required" class="col-xs-8 col-md-8" v-model="teamMember2.address" type="text">
                    </div>
                  </div>
                  <div class="col-xs-12 col-md-12 one-frame">

                    <span class="col-xs-4 col-md-4">上載文件(最多1.5MB)<label style="color: red">*</label>：</span>
                    <a href="" class="file" v-if="!teamMember2.id_card_urls">
                      <input class="img-file-input" required="required" type="file" name="file" accept="image/png,image/gif,image/jpeg" @change="secondChange1">
                      <div class="file-tips">點擊上傳相片</div>
                      學生證
                    </a>
                    <template v-if="teamMember2.id_card_urls">
                      <div class="image-change">
                        <input type="text" :value="teamMember2.id_card_name" >
                        <input type="hidden" :value="teamMember2.id_card_urls">
                        <a class="file">
                          <input  type="file" name="file" accept="image/png,image/gif,image/jpeg" @change="secondChange1">更换
                        </a>
                      </div>
                    </template>
                    <a href="" class="file" v-if="!teamMember2.student_picture_urls">
                      <input class="img-file-input" required="required" type="file" @change="secondChange2">
                      <div class="file-tips">點擊上傳相片</div>
                      請上載穿校服之近照</a>
                    <template v-if="teamMember2.student_picture_urls" >
                      <div class="image-change">
                        <input type="hidden" name="" :value="teamMember2.student_picture_urls">
                        <input type="text" name="" :value="teamMember2.student_picture_name">
                        <a class="file">
                          <input type="file" name="file" accept="image/png,image/gif,image/jpeg" @change="secondChange2">更换
                        </a>
                      </div>
                    </template>
                  </div>
                </div>
              </div>

              <div class="team-member ">
                <div class="one-member clearfix">
                  <h4>隊員二</h4>
                  <div class="col-xs-12 col-md-6 one-frame">

                    <span class="col-xs-4 col-md-4 none-padding-right">學生姓名<label style="color: red">*</label>：</span>
                    <input required="required" class="col-xs-8 col-md-8" v-model="teamMember3.student_name" type="text">
                  </div>
                  <div class="col-xs-12 col-md-6 one-frame">

                    <span class="col-xs-4 col-md-4 none-padding">學生證號碼<label style="color: red">*</label>：</span>
                    <input required="required" class="col-xs-8 col-md-8" v-model="teamMember3.id_card_number" type="text">
                  </div>
                  <div class="col-xs-12 col-md-6 one-frame">

                    <span class="col-xs-4 col-md-4 none-padding-right">手提電話<label style="color: red">*</label>：</span>
                    <input required="required" class="col-xs-8 col-md-8" v-model="teamMember3.mobile" type="text">
                  </div>
                  <div class="col-xs-12 col-md-6 one-frame">

                    <span class="col-xs-4 col-md-4">電郵<label style="color: red">*</label>：</span>
                    <input required="required" class="col-xs-8 col-md-8" v-model="teamMember3.email" type="text">
                  </div>
                  <div class="clearfix">
                    <div class="col-xs-12 col-md-6 one-frame">

                      <span class="col-xs-4 col-md-4">就讀中學名稱<label style="color: red">*</label>：</span>
                      <input required="required" class="col-xs-8 col-md-8" v-model="teamMember3.school" type="text">
                    </div>
                    <div class="col-xs-12 col-md-6 one-frame">

                      <span class="col-xs-4 col-md-4 none-padding-right">就讀年級<label style="color: red">*</label>：</span>
                      <select class="col-xs-8 col-md-8" v-model="teamMember3.grade" name="" id="">
                        <option value="1">初一</option>
                        <option value="2">初二</option>
                        <option value="3">初三</option>
                        <option value="4">高一</option>
                        <option value="5">高二</option>
                        <option value="6">高三</option>
                      </select>
                    </div>
                  </div>
                  <div class="clearfix">
                    <div class="col-xs-12 col-md-6 one-frame">

                      <span class="col-xs-4 col-md-4">地址<label style="color: red">*</label>：</span>
                      <input required="required" class="col-xs-8 col-md-8" v-model="teamMember3.address" type="text">
                    </div>
                  </div>
                  <div class="col-xs-12 col-md-12 one-frame">

                    <span class="col-xs-4 col-md-4">上載文件(最多1.5MB)<label style="color: red">*</label>：</span>
                    <a href="" class="file" v-if="!teamMember3.id_card_urls">
                      <input class="img-file-input" required="required" type="file" name="file" accept="image/png,image/gif,image/jpeg" @change="thridChange1">
                      <div class="file-tips">點擊上傳相片</div>
                      學生證
                    </a>
                    <template v-if="teamMember3.id_card_urls">
                      <div class="image-change">
                        <input type="text" :value="teamMember3.id_card_name" >
                        <input type="hidden" :value="teamMember3.id_card_urls">
                        <a class="file">
                          <input type="file" name="file" accept="image/png,image/gif,image/jpeg" @change="thridChange1">更换
                        </a>
                      </div>
                    </template>
                    <a href="" class="file" v-if="!teamMember3.student_picture_urls">
                      <input class="img-file-input" required="required" type="file" @change="thridChange2">
                      <div class="file-tips">點擊上傳相片</div>
                      請上載穿校服之近照</a>
                    <template v-if="teamMember3.student_picture_urls" >
                      <div class="image-change">
                        <input type="hidden" name="" :value="teamMember3.student_picture_urls">
                        <input type="text" name="" :value="teamMember3.student_picture_name">
                        <a class="file">
                          <input type="file" name="file" accept="image/png,image/gif,image/jpeg" @change="thridChange2">更换
                        </a>
                      </div>
                    </template>
                  </div>
                </div>
              </div>

              <div class="team-member ">

                <div class="one-member clearfix">
                  <h4>後備隊員</h4>
                  <div class="col-xs-12 col-md-6 one-frame">

                    <span class="col-xs-4 col-md-4 none-padding-right">學生姓名<label style="color: red">*</label>：</span>
                    <input required="required" class="col-xs-8 col-md-8" v-model="teamMember4.student_name" type="text">
                  </div>
                  <div class="col-xs-12 col-md-6 one-frame">

                    <span class="col-xs-4 col-md-4 none-padding">學生證號碼<label style="color: red">*</label>：</span>
                    <input required="required" class="col-xs-8 col-md-8" v-model="teamMember4.id_card_number" type="text">
                  </div>
                  <div class="col-xs-12 col-md-6 one-frame">

                    <span class="col-xs-4 col-md-4 none-padding-right">手提電話<label style="color: red">*</label>：</span>
                    <input required="required" class="col-xs-8 col-md-8" v-model="teamMember4.mobile" type="text">
                  </div>
                  <div class="col-xs-12 col-md-6 one-frame">

                    <span class="col-xs-4 col-md-4">電郵<label style="color: red">*</label>：</span>
                    <input required="required" class="col-xs-8 col-md-8" v-model="teamMember4.email" type="text">
                  </div>
                  <div class="clearfix">
                    <div class="col-xs-12 col-md-6 one-frame">

                      <span class="col-xs-4 col-md-4">就讀中學名稱<label style="color: red">*</label>：</span>
                      <input required="required" class="col-xs-8 col-md-8" v-model="teamMember4.school" type="text">
                    </div>
                    <div class="col-xs-12 col-md-6 one-frame">

                      <span class="col-xs-4 col-md-4 none-padding-right">就讀年級<label style="color: red">*</label>：</span>
                      <select class="col-xs-8 col-md-8" v-model="teamMember4.grade" name="" >
                        <option value="1">初一</option>
                        <option value="2">初二</option>
                        <option value="3">初三</option>
                        <option value="4">高一</option>
                        <option value="5">高二</option>
                        <option value="6">高三</option>
                      </select>
                    </div>
                  </div>
                  <div class="clearfix">
                    <div class="col-xs-12 col-md-6 one-frame">

                      <span class="col-xs-4 col-md-4">地址<label style="color: red">*</label>：</span>
                      <input required="required" class="col-xs-8 col-md-8" v-model="teamMember4.address" type="text">
                    </div>
                  </div>
                  <div class="col-xs-12 col-md-12 one-frame">

                    <span class="col-xs-4 col-md-4">上載文件(最多1.5MB)<label style="color: red">*</label>：</span>
                    <a href="" class="file" v-if="!teamMember4.id_card_urls">
                      <input class="img-file-input" required="required" type="file" name="file" accept="image/png,image/gif,image/jpeg" @change="fourthChange1">
                      <div class="file-tips">點擊上傳相片</div>
                      學生證
                    </a>
                    <template v-if="teamMember4.id_card_urls">
                      <div class="image-change">
                        <input type="text" :value="teamMember4.id_card_name" >
                        <input type="hidden" :value="teamMember4.id_card_urls">
                        <a class="file">
                          <input type="file" name="file" accept="image/png,image/gif,image/jpeg" @change="fourthChange1">更换
                        </a>
                      </div>
                    </template>
                    <a href="" class="file" v-if="!teamMember4.student_picture_urls">
                      <input class="img-file-input" required="required" type="file" @change="fourthChange2">
                      <div class="file-tips">點擊上傳相片</div>
                      請上載穿校服之近照</a>
                    <template v-if="teamMember4.student_picture_urls" >
                      <div class="image-change">
                        <input type="hidden" name="" :value="teamMember4.student_picture_urls">
                        <input type="text" name="" :value="teamMember4.student_picture_name">
                        <a class="file">
                          <input type="file" name="file" accept="image/png,image/gif,image/jpeg" @change="fourthChange2">更换
                        </a>
                      </div>
                    </template>
                  </div>
                </div>
              </div>

              <div class="identifying-code clearfix">
                <div class="col-xs-12 ">
                    <div class="col-xs-12 col-sm-6 code-input">
                      <span>驗證：</span>
                      <input required="required" type="text" v-model="inputCode">
                      <img :src="code" @click="changeCode" alt="验证码" style="cursor: pointer">
                    </div>
                    <!--<button type="button" class="col-xs-12 col-sm-5 col-sm-offset-1" @click="addPost">提交</button>-->
                    <button type="submit" class="col-xs-12 col-sm-5 col-sm-offset-1">提交</button>
                    <div v-if="tips" class="col-xs-12" style="text-align: center; margin-top: 15px; color: red;">
                      {{tips}}
                    </div>
                </div>
              </div>

              <div class="ruler">
                備註<br>
                * 比賽以粵語進行；<br>
                * 比賽隊名不可有不雅字眼；<br>
                * 根據第8/2005號法律《個人資料保護法》處理即保存以上個人資料；資料只會用於此項活動相關用途；<br>
                * 主辦單位擁有報導、宣傳活動之權利，於活動期間所拍攝照片將可用於日後之宣傳用途；<br>
                * 主辦單位對活動參賽規則及條款保留最終解釋及決定權。<br>
              </div>
            </form>
          </template>
          <templaet v-else-if="otherDetail.start_time > nowTime">
            <div class="enroll-success">
              滙業盃中學生常識問答比賽報名將於 <span style="color: red">{{otherDetail.start_time*1000|datefmt("YYYY年MM月DD日")}}</span>至
              <span style="color: red">{{otherDetail.end_time*1000|datefmt("YYYY年MM月DD日")}}</span>接受報名
            </div>
          </templaet>
          <template v-else-if="otherDetail.end_time < nowTime">
            <div  class="enroll-success">報名已結束</div>
          </template>
        </div>
        <div class="hy-form col-xs-12 col-sm-8 col-sm-offset-2 none-padding" v-if="isSuccess">
          <div class="enroll-success">
            <div class="suc-title">完成報名</div>
            <div class="suc-content">感謝閣下參加滙業盃！確認電郵已傳到<span style="color: rgba(85,113,236,1)">{{sEmail}}</span></div>
            <div class="suc-content">&nbsp;&nbsp;謝謝！</div>
            <div class="suc-content">滙業盃</div>
            <button @click="ThisRefresh">完成</button>
          </div>
        </div>
      </template>
    </content-template>
  </div>

</template>
<script>
import contentTemplate from '../contentTemplate'
import Vue from 'vue'
export default {
  components: {
    'content-template': contentTemplate
  },
  data () {
    return {
      otherDetail: [],
      nowTime: 0,
      inputCode: '',   // 表单数据
      tips: '',
      isSuccess: false,
      sEmail: '',
      team: {
        group: '1',
        team_cate: '2'
      },
      teamMember1: {
        grade: 1,
        position: 1
      },
      teamMember2: {
        grade: 1,
        position: 2
      },
      teamMember3: {
        grade: 1,
        position: 2
      },
      teamMember4: {
        grade: 1,
        position: 3
      },
      code: this.$url + 'home/code',
      codeNum: '',
      photoResource: {
        url: 'aaa',
        filename: 'bbb'
      }  // 照片上传后返回的资源
    }
  },
  mounted: function () {
    var nowTime = Date.parse(new Date()).toString()
    this.nowTime = nowTime.substr(0, 10)
    this.getOther()
  },
  computed: {
  },
  methods: {
    getOther: function () {
      var that = this
      this.$axios.get('/huiye/other')
        .then(function (response) {
          that.otherDetail = response.data.data
          // console.log(response.data)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    ThisRefresh: function () {
      // this.router.push({path: '/online-enroll', query: {id: that.$router.query.id}})
      this.$router.push({name: 'index'})
    },
    changeCode: function () {
      this.code = this.$url + 'home/code?d=' + Math.random()
    },
    addPost: function () {
      const that = this
      var inputData = {
        code: this.inputCode,
        team: this.team,
        teamMember: [this.teamMember1, this.teamMember2, this.teamMember3, this.teamMember4]
      }
      this.$axios({
        url: 'huiye/add',
        method: 'post',
        data: this.$qs.stringify(inputData)
      })
        .then(function (response) {
          if (response.data.code === 1) {
            // that.$router.push('huiye-success')
            that.isSuccess = true
            that.sEmail = response.data.data
            setTimeout (function () {
              that.$router.push({name: 'index'})
            }, 5000)
          } else {
            that.tips = response.data.msg
            that.changeCode()
          }
          // console.log(response.data)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    update: function (e, self, data, card) {
      var that = this
      let file = e.target.files[0]
      let param = new FormData()  // 创建form对象
      param.append('file', file, file.name)
      // console.log(param.get('file'))
      let config = {
        headers: {'Content-Type': 'multipart/form-data'}
      }
      console.log(data)
      var url = '/user/upload/one'
      self.$axios.post(url, param, config)
        .then(function (response) {
          // 成功返回图片名称和图片存储路径
          if (response.data.code === 1) {
            // Vue.set(self.photoResource, 'filename', response.data.data.filename)
            if (card) {
              Vue.set(data, 'id_card_name', response.data.data.filename)
              Vue.set(data, 'id_card_urls', response.data.data.url)
            } else {
              Vue.set(data, 'student_picture_name', response.data.data.filename)
              Vue.set(data, 'student_picture_urls', response.data.data.url)
            }
            // console.log('sss', response.data.data)
            // console.log('aaa', self.fourthStu)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    firstChange1: function (e) {
      var self = this
      this.update(e, self, this.teamMember1, true)
    },
    firstChange2: function (e) {
      var self = this
      this.update(e, self, this.teamMember1, false)
    },
    secondChange1: function (e) {
      var self = this
      this.update(e, self, this.teamMember2, true)
    },
    secondChange2: function (e) {
      var self = this
      this.update(e, self, this.teamMember2, false)
    },
    thridChange1: function (e) {
      var self = this
      this.update(e, self, this.teamMember3, true)
    },
    thridChange2: function (e) {
      var self = this
      this.update(e, self, this.teamMember3, false)
    },
    fourthChange1: function (e) {
      var self = this
      this.update(e, self, this.teamMember4, true)
    },
    fourthChange2: function (e) {
      var self = this
      this.update(e, self, this.teamMember4, false)
    }
  }
}
</script>
<style scoped>


  .container {
    padding: 0px;
  }

  .hy-top {
    height: 70px;
    width: 100%;
    border: 2px solid #00A9E2;
    border-radius: 8px;
  }

  .hy-top .top-left, .hy-top .top-right {
    margin-top: 10px;
  }

  .label-div {
    display: inline-block;

  }

  .labels {
    display: inline-block;
    background: #F7B400;
    color: #ffffff;
    text-align: center;
    width: 20px;
    height: 20px;
    border-radius: 10px;
  }

  .hy-top .label1 {
    display: inline-block;
  }

  .title {
    font-size: 16px;
  }

  .desc {
    font-size: 12px;
    color: #565656;
  }

  /*頂部提示結束*/

  .hy-form {
    margin-top: 20px;
  }
  /*參賽隊伍資料*/
  .hy-form h4 {
    color: #617BE4;
    font-size: 16px;
  }

  .hy-form table {
    /*border-collapse: collapse;*/
    padding: 0px;
  }

  .hy-form tr {
    /*margin-top: 20px;*/
    padding-top: 20px;
    height: 60px;
  }

  .hy-form th, .hy-form td {
    padding: 0.3em;
  }

  .hy-form th {
    font-size: 14px;
  }

  .hy-form .img-file-input{
    width: 120px;
    height: 50px;
  }

  .hy-form .input-radio {
    /*vertical-align: middle;*/
  }

  .hy-form .tips {
    margin-left: 10px;
    font-size: 12px;
    color: #4A4A4A;
  }

  .hy-form .input-width {
    width: 100%;
  }

  .team {
    margin-top: 20px;
    padding: 0px;
  }

  .team input {
    /*width: 100%;*/
    background: #F2F7FC;
    border: 1px solid #DCDEE1;
    border-radius: 8px;
  }

  .team select {
    background: #F2F7FC;
    border: 1px solid #DCDEE1;
    border-radius: 8px;
    z-index: 1;
  }

  .one-frame {
    margin-bottom: 10px;
  }

  .team-member, .identifying-code, .ruler {
    margin-bottom: 15px;
  }
  .ruler{
    padding: 15px;
  }

  .team-member .one-member {
    background: #F4F4F4;
    border-radius: 8px;

  }

  .team-member .one-member h4 {
    color: #000;
    margin-left: 25px;
  }

  .team-member .one-member input {
    border: 1px solid #DCDEE1;
    border-radius: 8px;
  }

  .team-member .one-member select {
    background: #FFFFFF;
    border: 1px solid #DCDEE1;
    border-radius: 8px;
  }

  .team-member .one-member .file {
    position: relative;
    display: inline-block;
    background: #ffffff;
    border: 1px solid #DCDEE1;
    border-radius: 4px;
    padding: 4px 12px;
    overflow: hidden;
    text-decoration: none;
    text-indent: 0;
    line-height: 20px;
    cursor: pointer;
    text-align: center;
    color: #000;
  }

  .team-member .one-member .file input {
    position: absolute;
    font-size: 100px;
    right: 0;
    top: 0;
    opacity: 0;
  }

  .team-member .one-member .file .file-tips {
    font-size: 15px;
    color: #B2B2B2;
  }


  .identifying-code {
    background: #F2F7FC;
    border-radius: 8px;
    padding-top: 20px;
    padding-bottom: 20px;
    font-size: 16px;
  }
  .identifying-code .code-input{
    text-align: right;
  }
  .identifying-code input {
    width: 100px;
    border: 1px solid #DCDEE1;
    border-radius: 8px;
  }

  .identifying-code button {
    background: #5571EC;
    border-radius: 100px;
    width: 100px;
    height: 40px;
    color: #fff;
  }

  .ruler {
    background: #FFFFFF;
    border: 1px solid #DCDEE1;
    border-radius: 8px;
  }
  .image-change{
    position: relative;
    display: inline-block;
  }
  .image-change input{
    position: absolute;
  }
  .image-change a{
    margin-left: 155px;
  }

  .suc-title{
    font-size: 24px;
    color: #565656;
    text-align: center;
  }
  .suc-content{
    font-size: 18px;
    color: #4A4A4A;
    letter-spacing: 0;
    text-align: center;
  }

  @media (min-width: 992px) {
    .hy-top .top-left {
      border-right: 1px solid #C0C2C5;
    }
  }

  @media (max-width: 992px) {
    .hy-top {
      height: 105px;
    }

    .hy-top .top-left {
      border-bottom: 1px solid #C0C2C5;
    }
  }

  @media (max-width: 768px) {
    .hy-form {
      font-size: 14px;
    }

    .identifying-code .code-input{
      font-size: 14px;
      padding: 0px;
      text-align: left;
      width: 60%;
    }

    .hy-top .top-left, .hy-top .top-right{
      margin-top: 5px;
    }
  }

  @media (max-width: 767px){
    .identifying-code .code-input{
      width: 100%;
      text-align: center;
    }
    .identifying-code button {
      margin-top: 15px;
      margin-left: 25%;
      width: 50%;
    }
    .identifying-code input{
      /*width: 60px;*/
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/huiye/index.vue